// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__gmCwu","col":"styles_col__1i1zt"};